import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../hooks/hooks';
import type { JSX } from 'react';

interface PublicRouteProps {
  children: JSX.Element;
}

export default function PublicRoute({ children }: PublicRouteProps) {
  const user = useAppSelector((state) => state.auth.user);

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
